import * as Yup from 'yup';

export const loginModel = {
  email: {
    name: 'email',
    label: 'Tu correo electrónico',
    required: true,
    requiredErrorMsg: 'Campo requerido',
    invalidErrorMsg: 'Ingresar un correo electrónico válido',
  },
  password: {
    name: 'password',
    label: 'Tu contraseña',
    required: true,
    requiredErrorMsg: 'Campo requerido',
  },
};

const { email, password } = loginModel;

export const loginInitialState = {
  [email.name]: '',
  [password.name]: '',
};

export const loginValidationSchema = Yup.object().shape({
  [email.name]: Yup.string()
    .email(email.invalidErrorMsg)
    .required(email.requiredErrorMsg),
  [password.name]: Yup.string().required(password.requiredErrorMsg),
});
